/**
 * JavaScript for Image Video block
 */

class ImageVideo {
  constructor($element) {
    this.$element = $element;
    this.init();
  }

  async init() {
    try {
      await this.loadVimeoAPI();
    } catch (e) {
      return;
    }

    this.$element.find('.gg-image-video__media').each((_index, media) => {
      const $media   = $(media);
      const $iframe  = $media.find('.gg-image-video__video');
      const $playBtn = $media.find('.gg-image-video__btn--play');
      const $muteBtn = $media.find('.gg-image-video__btn--mute');

      if (!$iframe.length) return;

      let player = null;

      const initPlayer = async () => {
        if (player) return player;
        player = new Vimeo.Player($iframe[0]);
        await player.ready();
        try { await player.setMuted(false); } catch (e) {}
        player.on('play',  () => $playBtn.addClass('is-playing'));
        player.on('pause', () => $playBtn.removeClass('is-playing'));
        return player;
      };

      // Add video-loaded only after Vimeo confirms the embed is valid (status 200).
      // player.ready() rejects for 404 / private videos, keeping the poster visible.
      $iframe.on('load', async () => {
        try {
          await initPlayer();
          $media.addClass('video-loaded');
        } catch (e) {
          player = null; // reset so getPlayer() can retry if user clicks
        }
      });

      const getPlayer = async () => initPlayer();

      $playBtn.on('click', async () => {
        try {
          const p = await getPlayer();
          if ($playBtn.hasClass('is-playing')) {
            await p.pause();
          } else {
            await p.play();
          }
        } catch (e) { }
      });

      $muteBtn.on('click', async () => {
        try {
          const p = await getPlayer();
          const muted = await p.getMuted();
          await p.setMuted(!muted);
          // Ensure we get the actual mute state after setting
          const newMuted = await p.getMuted();
          $muteBtn.toggleClass('is-muted', newMuted);
        } catch (e) { }
      });
    });
  }

  loadVimeoAPI() {
    if (window.Vimeo) return Promise.resolve();
    return new Promise((resolve, reject) => {
      const existing = document.querySelector('script[src*="player.vimeo.com/api/player.js"]');
      if (existing) {
        const poll = setInterval(() => {
          if (window.Vimeo) { clearInterval(poll); resolve(); }
        }, 50);
        return;
      }
      const script = document.createElement('script');
      script.src = 'https://player.vimeo.com/api/player.js';
      script.onload = resolve;
      script.onerror = reject;
      document.head.appendChild(script);
    });
  }
}

$(document).ready(() => {
  $('.gg-image-video').each((_index, element) => {
    new ImageVideo($(element));
  });
});
